import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

interface SimpleAccordionProps {
  header: string;
  children: React.ReactNode;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
    },
    heading: {
      letterSpacing: "0.5px",
      position: "relative",
      display: "block",
      padding: "8px 25px 8px 0",
      textDecoration: "none",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    details: {
      display: "flex",
      justifyContent: "center",
      padding: "16px",
    },
    text: {
      fontSize: "14px",
      fontFamily: "inherit",
      lineHeight: "1.42857143",
      color: "#6d6d6d",
      width: "100%",
    },
  })
);

export default function CustomAccordion({
  header,
  children,
}: SimpleAccordionProps) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography className={classes.heading}>{header}</Typography>
        </AccordionSummary>
        <AccordionDetails className={classes.details}>
          <div className={classes.text}>{children}</div>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
